var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDistribution = function SvgDistribution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.877 24.182 54.606 16h-3.61l-7.242 8.185 2.34 2.07 5.153-5.823v10.11l-4.374 4.15H17v3.125h31.12l6.252-5.932V20.44l5.17 5.818 2.335-2.076ZM74.08 46.944l-8.182 7.271-2.075-2.336 5.817-5.17L17 46.707v-3.124l52.647.003-5.823-5.153 2.07-2.34 8.185 7.243v3.609ZM41.711 75.017l7.272-8.182-2.336-2.075-5.17 5.817V57.843l-6.252-5.931H17v3.124h16.978l4.375 4.15v11.4l-5.154-5.824-2.34 2.07 7.243 8.186h3.61Z",
    fill: "currentColor"
  })));
};
export default SvgDistribution;